import i18n from "@/boot/i18n";

const getAddressName = (value) => {

  const addressObj = JSON.parse(value)
  const addressFields = ['Street', 'PostalCode', 'City', 'State', 'CountryOrRegion', 'streetAddress', 'postalCode', 'city', 'country'];


  return addressFields.reduce((addressString, addressField) => {

    if (addressObj[addressField]) {
      return `${addressString} ${addressObj[addressField]},`
    }
    return addressString;

  }, '')
}

const getLocationName = (value) => {
  const locationObj = JSON.parse(value)

  if (locationObj && locationObj['DisplayName']) {
    return location && locationObj['DisplayName']
  }

  return i18n.t('common.na')
}

const getStatusLabel = (value) => {

  if (value === 3) {
    return i18n.t('recovery.statusOptions.completed');
  } else if (value === 4) {
    return i18n.t('recovery.statusOptions.failed');
  } else if (value === -1) {
    return i18n.t('recovery.statusOptions.cancelled');
  }

  return '/'
}


const convertSize = (size) => {
  const unitKeys = [
    'bytes', 'kb', 'mb', 'gb', 'tb', 'pb', 'eb', 'zb', 'yb'
  ];

  let l = 0;
  let n = parseInt(size, 10) || 0;

  while (n >= 1024 && ++l) {
    n = n / 1024;
  }

  const unitLabel = i18n.t(`common.sizeUnits.${unitKeys[l]}`);

  return `${n.toFixed(n < 10 && l > 0 ? 2 : 0)} ${unitLabel}`;
};

const getEllipsisStr = (str, characters = 6, charactersLength) => {
  if (str?.length > charactersLength) {
    return str.slice(0, characters) + '...' + str.slice(-characters)
  }
  return str
}

export {
  getAddressName,
  getLocationName,
  convertSize,
  getStatusLabel,
  getEllipsisStr,
}
